import Repository from "@shared/services/api/abstracts/Repository";

export interface KeyValueParamSerializer {
  key: string;
  value: string;
}

export default class PublicKeyValueParamsRepository extends Repository<KeyValueParamSerializer> {
  public readonly repositoryName = "PublicKeyValueParamsRepository";

  public readonly endpoint = "api/public/key-value-params/";
}
